/* Palsora wishlist: saved in this browser (localStorage). Hearts use [data-pals-wish][data-handle]. */
(function () {
  if (window.PalsWish) return;
  var KEY = 'palsWishlist', toast, toastTimer;

  function get() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function set(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  function sync() {
    var list = get();
    document.querySelectorAll('[data-pals-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.querySelector('[data-wish-label]');
      if (label) label.textContent = on ? 'Saved to wishlist' : 'Save to wishlist';
    });
    document.querySelectorAll('[data-pals-wish-count]').forEach(function (c) {
      var changed = c.textContent !== String(list.length);
      c.textContent = list.length;
      c.hidden = list.length === 0;
      if (changed && list.length) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
    });
  }

  function say(text) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pals-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    var link = document.querySelector('.pals-header__wish');
    toast.innerHTML = '<span></span>' + (link ? ' <a href="' + link.getAttribute('href') + '">View wishlist</a>' : '');
    toast.firstChild.textContent = text;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2200);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pals-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-handle');
    if (!h) return;
    var list = get(), i = list.indexOf(h), added = i === -1;
    if (added) list.unshift(h); else list.splice(i, 1);
    set(list.slice(0, 60));
    sync();
    say(added ? 'Saved to your wishlist' : 'Removed from your wishlist');
    document.dispatchEvent(new CustomEvent('pals:wish:change', { detail: { handle: h, added: added } }));
  });

  // keep several open tabs in step
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  window.PalsWish = { get: get, set: set, sync: sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
